export enum WeekdayToggleMessages {
  MONDAY = 'M',
}
